import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a5d72328"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "modal-title" }, "Unable to sign in.")
], -1))
const _hoisted_2 = { class: "box-body" }
const _hoisted_3 = { class: "image-wrapper" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _ctx.isShow,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isShow) = $event)),
    width: "640",
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { id: "modalOBPassword" }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("img", {
                class: "alertAttemptsImage",
                src: _ctx.alertAttemptsImageSrc,
                alt: ""
              }, null, 8, _hoisted_4)
            ]),
            _createElementVNode("p", {
              class: "description-text",
              innerHTML: _ctx.descriptionHtml
            }, null, 8, _hoisted_5),
            _createElementVNode("p", {
              class: "warning-text",
              innerHTML: _ctx.warningHtml
            }, null, 8, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              class: "btn btn-try-again",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.HandleTryAgain && _ctx.HandleTryAgain(...args)))
            }, " Try again "),
            _createElementVNode("button", {
              class: "btn btn-forgot-password",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.HandleForgotPassword && _ctx.HandleForgotPassword(...args)))
            }, " Forgot password ")
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}